import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Icon } from 'rsuite';
import {
  showCameraRecorder,
  getIsVideoUploadingToBucket,
} from '../../redux/modules/campaignLandingPage';
import styles from './VideoRecorderEnableButton.module.less';
import { isRecordingSupported } from '../../helpers/supportedFeatureHelper';

const VideoRecorderEnableButton = ({
  _showCameraRecorder,
  qid,
  isVideoUploading,
}) => {
  if (!isRecordingSupported()) {
    return null;
  }

  return (
    <>
      <label
        htmlFor={styles.vpEnableCameraButton}
        className={`${styles.vpRecordVideoButton} ${isVideoUploading ? styles.vpInputDisabled : ''}`}
      >
        <Button
          id={styles.vpEnableCameraButton}
          disabled={isVideoUploading}
          onClick={() => _showCameraRecorder(qid)}
          appearance="primary"
          className={`${styles.vpEnableCameraButton} ${isVideoUploading ? styles.vpInputDisabled : ''}`}
        >
          <Icon icon="circle" />
          Record a Video
        </Button>
      </label>
    </>
  );
};

VideoRecorderEnableButton.propTypes = {
  _showCameraRecorder: PropTypes.func,
  qid: PropTypes.string,
  isVideoUploading: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    isVideoUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
  };
}

const mapDispatchToProps = {
  _showCameraRecorder: showCameraRecorder,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoRecorderEnableButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoRecorderEnableButton.jsx